module.exports = __webpack_public_path__ + "img/avatar-51.ca0dc3e0.png";